<rw-modal
  modalId="folder-org-rename-error-modal"
  datapendoid="folder-org-rename-error-modal"
  datatestid="folder-org-rename-error-modal"
  [title]="'We can\'t ' + verb + ' your ' + type + ' right now'"
  arialabel="We can't {{ verb }} your {{ type }} right now"
  [dismissible]="true"
  size="lg"
  #modalRef
>
  <div modal-body>
    <div class="col-md-11 rename-desc">
      We can't {{ verb }} your {{ type }} because some of your users are logged in to their cloud-hosted desktops. Have
      these users log off, then try again:
    </div>
    <div class="user-list">
      <ul>
        @for (user of usersLoggedIn; track user) {
          <li>{{ user.OrganizationName }}: {{ user.FullName }}</li>
        }
      </ul>
    </div>
  </div>
  <div modal-footer>
    <app-button id="btnClose" buttonStyle="addUserTeritary" label="CANCEL" (clickActionEmitter)="close()"> </app-button>
  </div>
</rw-modal>
